import InboxSvg from '@assets/images/svg/inbox.svg';
import React from 'react';
import { View } from 'react-native';

export interface InboxIconProps {
  size?: number;
  color?: string;
}

const ASPECT = 10 / 16;

/**
 * Inbox tray (Figma reservation “complete within 15 days” step).
 * Default color matches original SVG fill (#333333).
 */
export function InboxIcon({
  size = 16,
  color = '#333333',
}: Readonly<InboxIconProps>) {
  const width = size;
  const height = size * ASPECT;

  return (
    <View
      style={{
        width,
        height,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <InboxSvg width={width} height={height} color={color} />
    </View>
  );
}

export default InboxIcon;
